const HU = {
  listedPublicCompany: [
    "zártkörűen működő részvénytársaság (Nyrt.)"
  ],
  nonProfit: [
    "közhasznú társaság (Kht.)"
  ],
  privateCompany: [
    "korlátolt felelősségű társaság (Kft.)",
    "zártkörűen működő részvénytársaság (Zrt.)"
  ]
};
export {
  HU as default
};
